import { AccountLinkProposalType } from '@/shared/types/sign/account-link';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * 계정 통합 확인 모달의 컨텍스트.
 *
 * 소셜 로그인/이메일 가입 응답에 `linkProposal` 이 오면 각 진입점(소셜 훅·이메일 가입 훅)이
 * 이 store 를 열어 `AccountLinkModal` 을 띄운다. 진입점마다 로그인 후처리 방식이 다르므로,
 * 그 결정을 store 가 아니라 호출측 콜백(`onLinked`)에 위임한다.
 */
export interface AccountLinkContext {
  proposal: AccountLinkProposalType;
  /** link-confirm 성공 후 각 진입점의 기존 로그인 성공 처리를 재사용한다. */
  onLinked: (tokens: {
    accessToken: string;
    refreshToken: string;
  }) => Promise<void>;
  /** 이메일 가입 방향 전용 — confirm payload 에 함께 보낼 password/인증코드. */
  emailSignupPayload?: { password: string; verificationCode: string };
}

export interface AccountLinkStore {
  context: AccountLinkContext | null;
}

export interface AccountLinkStoreActions {
  open: (context: AccountLinkContext) => void;
  close: () => void;
}

export const useAccountLinkStore = create<
  AccountLinkStore & AccountLinkStoreActions
>()(
  devtools((set) => ({
    context: null,
    open: (context: AccountLinkContext) => set({ context }),
    close: () => set({ context: null }),
  })),
);
